import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMG } from "../../lib/assets";

export const CampaignMessage = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} className="relative overflow-hidden bg-slate-900 py-28 lg:py-40" data-testid="campaign-message-section">
      {/* background image with heavy overlay */}
      <motion.img
        src={IMG.school}
        alt=""
        aria-hidden="true"
        style={{ y }}
        className="absolute inset-0 w-full h-[120%] object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-slate-900/70" />

      {/* wave graphics */}
      <svg className="absolute bottom-0 left-0 w-full text-teal-500/10" viewBox="0 0 1440 320" preserveAspectRatio="none" aria-hidden="true">
        <path fill="currentColor" d="M0,192L48,197.3C96,203,192,213,288,202.7C384,192,480,160,576,165.3C672,171,768,213,864,224C960,235,1056,213,1152,181.3C1248,149,1344,107,1392,85.3L1440,64L1440,320L0,320Z" />
      </svg>
      <svg className="absolute top-0 right-0 w-full text-teal-400/5 rotate-180" viewBox="0 0 1440 320" preserveAspectRatio="none" aria-hidden="true">
        <path fill="currentColor" d="M0,96L48,122.7C96,149,192,203,288,208C384,213,480,171,576,154.7C672,139,768,149,864,170.7C960,192,1056,224,1152,213.3C1248,203,1344,149,1392,122.7L1440,96L1440,320L0,320Z" />
      </svg>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs font-semibold tracking-[0.25em] uppercase text-teal-300"
        >
          Campaign Message
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-extrabold tracking-tight text-white text-4xl md:text-6xl mt-4 leading-[1.05]"
        >
          It's Time For A <span className="text-teal-300">Fresh Voice</span>
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-8 space-y-5 text-lg text-slate-200 leading-relaxed"
        >
          <p>
            Pembina Trails is changing. Our schools should benefit from new ideas, strong
            community connections, and leadership focused on students and families.
          </p>
          <p className="text-white font-medium">
            Noman Zaheer represents a fresh perspective rooted in community, innovation,
            and a commitment to educational excellence.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
